import { ErrorListItem, ListContentIsland, ListItem, TextField, Collapse } from '@razz-team/ui-web';
import { useDeferredValue, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBusinessMembersQuery } from '../../../../api/members';
import { MemberListItem } from './MemberListItem';
import { TransitionGroup } from 'react-transition-group';

export function MembersIsland({ isSearchEnabled = false }: { isSearchEnabled?: boolean }) {
  const { t } = useTranslation();
  const membersQuery = useBusinessMembersQuery();

  const [query, setQuery] = useState('');
  const deferredQuery = useDeferredValue(query);

  const filteredMembers = useMemo(() => {
    const q = deferredQuery.trim().toLocaleLowerCase();
    if (!membersQuery.data?.members || q === '') return membersQuery.data?.members ?? [];
    return membersQuery.data.members.filter((member) => {
      if (member.customer.id === q) return true;
      if (member.identity.email?.toLocaleLowerCase().includes(q)) return true;
      if (member.identity.phone?.includes(q)) return true;
      if (member.individual.name?.firstName?.toLocaleLowerCase().includes(q)) return true;
      if (member.individual.name?.lastName?.toLocaleLowerCase().includes(q)) return true;
      if (member.membership.role?.toLocaleLowerCase().includes(q)) return true;
      return false;
    });
  }, [membersQuery.data?.members, deferredQuery]);

  const hasResults = (filteredMembers?.length ?? 0) > 0;

  return (
    <ListContentIsland>
      {isSearchEnabled && (
        <ListItem>
          <TextField
            type="search"
            label={t('Search')}
            size="small"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            fullWidth
          />
        </ListItem>
      )}
      {membersQuery.isPending ? (
        <MemberListItem member={undefined} loading />
      ) : membersQuery.isError ? (
        <ErrorListItem error={membersQuery.error} />
      ) : hasResults ? (
        <TransitionGroup>
          {(isSearchEnabled ? filteredMembers : (membersQuery.data?.members ?? [])).map(
            (member) => (
              <Collapse key={member.membership.id} in timeout={100}>
                <div>
                  <MemberListItem member={member} link />
                </div>
              </Collapse>
            ),
          )}
        </TransitionGroup>
      ) : (
        <ListItem>{t('No members found')}</ListItem>
      )}
    </ListContentIsland>
  );
}
